import { Injectable } from '@angular/core';
import { environment } from "../environments/environment";
import { Http, Response } from "@angular/http";
import { Observable } from "rxjs/Observable"

import "rxjs/add/operator/map";

@Injectable()
export class DownloadMonthlyApiService {
    constructor(private downloadMonthlyApi: Http) {
    }
    
}


// WEBPACK FOOTER //
// /Users/muhammadfiqihfirdiansyah/Documents/Muhammad Fiqih Firdiansyah/Project/Angular/BODES/BODES.Web.UI.Angular4/src/data/DownloadMonthlyApi.service.ts